// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"65":"27138d40","157":"29a72579","237":"ae14d678","283":"4a868090","322":"b7bf4900","384":"82445632","609":"887c43d0","638":"d2e039e5","891":"8d45d1e9"}[chunkId] + ".chunk.js";
};